module.exports = __webpack_public_path__ + "assets/RetinaNarr-Thin.ca7ea97dcc7e6b39362314a20b73eb07.woff2";